export const MODULE_NAME = 'users';
export const USERS = 'users';
export const SET_USERS = 'setUsers';
export const DELETE_USER = 'DeleteUser';
import {
	LOADING as loading,
	SET_LOADING as setLoading
} from '@/sections/loading-mutation-types';

export const LOADING = loading;
export const SET_LOADING = setLoading;

export const RELOAD_USERS = 'reloadUsers';
export const SET_RELOAD_USERS = 'SetReloadUsers';
export const USER_HISTORY_LOGS = 'userHistoryLogs';
export const SET_USER_HISTORY_LOGS = 'SetUserHistoryLogs';

import { TOAST_MESSAGES_PUSH as toastMessagesPush } from '@/sections/toast-mutation-types';

export const TOAST_MESSAGES_PUSH = toastMessagesPush;
